import { Warning, RawWarningResponse } from 'helper/home';
import { ListWarningsResponse } from 'services/api/home';

/* eslint-disable import/prefer-default-export */
export function transformListWarnings(response: ListWarningsResponse): Warning[] {
  return response.data.map((rawWarning: RawWarningResponse) => ({
    id: rawWarning.id,
    title: rawWarning.titulo,
    message: rawWarning.mensagem,
    timestamp: rawWarning.timestamp,
    expirationTime: rawWarning.horas_restantes,
  }));
}
